<ng-template #itemContent>
  <div class="item-content">
    <div class="item-main">
      <h3>{{ template.name }}</h3>
      <p class="version">v{{ template.version }}</p>
    </div>
    <div class="list-actions">
      @if (template.s3_key) {
        <button mat-icon-button (click)="downloadTemplate($event)" matTooltip="Download">
          <mat-icon>download</mat-icon>
        </button>
        <button mat-icon-button (click)="openPreview(template, $event)" matTooltip="Preview">
          <mat-icon>preview</mat-icon>
        </button>
      }
      <button mat-icon-button (click)="uploadFile(template, $event)" matTooltip="Upload file">
        <mat-icon>upload</mat-icon>
      </button>
      @if (template.is_latest) {
        <span class="badge">Latest</span>
      }
    </div>
  </div>
</ng-template>

@if (isLink) {
  <a class="template-list-item" [routerLink]="template.id">
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </a>
} @else {
  <button type="button" class="template-list-item btn-reset" (click)="openDetails(template, $event)">
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </button>
}
